import { Crown, Shield, Star } from 'lucide-react';

export const TIER_CONFIG = {
  alpha: { label: 'Alpha', color: 'text-yellow-400', bg: 'bg-yellow-500/20 border-yellow-500/40', icon: Crown },
  beta: { label: 'Beta', color: 'text-blue-400', bg: 'bg-blue-500/20 border-blue-500/40', icon: Shield },
  omega: { label: 'Omega', color: 'text-purple-400', bg: 'bg-purple-500/20 border-purple-500/40', icon: Star },
};
